module.exports = __webpack_public_path__ + "img/1.960b62fd.png";